import React from 'react';
import styled from 'styled-components';
import fifthsectionImage from '../../assets/fifthsectionImage.png';
import reviewImageone from '../../assets/reviewImagefirst.png';

export default function FifthSection() {
 return (
  <Container id='aboutdiv'>
   <Wrapper>
    <InfoSection />
    <Actionbutton />
    <Reviewsection />
   </Wrapper>
   <div className='bg'></div>
  </Container>
 );
}

function InfoSection() {
 return (
  <InfoContainer>
   <div>
    <div className='header'>
     <Heading>ABOUT ZIGMA</Heading>
     <Linebreak>
      <div className='part1'></div>
      <div className='part2'></div>
      <div className='part3'></div>
     </Linebreak>
    </div>
    <Content>
     <p>
      Zigma Global offers solutions involving segregation, treatment, recycling
      and thus clearing landfills across India. Equipped with a radical strategy
      and a disruptive technology we are working to eradicate and clear the
      solid waste legacy landfills. Our team of Experts and Environmental
      Engineers work with a mission of transforming the waste in the dump yards
      to add immense value in the value chain of Renewable energy. At Zigma, we
      create wealth,employment and sustainable development for mother earth’s
      stake holders.
     </p>{' '}
    </Content>
   </div>
   <div>
    <Image src={fifthsectionImage} alt='hand holding a small plant' />
   </div>
  </InfoContainer>
 );
}

function Actionbutton() {
 return (
  <Buttondiv>
   <div className='button'>1.6M+ tons of Methane saved</div>
   <div className='button'>6M+ tons of MSW processed across India</div>
   <div className='button'>30 locations across India</div>
  </Buttondiv>
 );
}

function Reviewsection() {
 return (
  <Reviewdiv>
   <div className='review'>
    <div className='header'>
     <Heading>Testimonials</Heading>
     <Linebreak>
      <div className='part1'></div>
      <div className='part2'></div>
      <div className='part3'></div>
     </Linebreak>
    </div>
    <Content>
     <p>
      Zigma has helped us track the complete journey of our plastic waste from
      source to cement processing units where it is upcycled and used for energy
      generation. This kind of transparency and traceability are important for a
      responsible organisation like Sakthi Masala
     </p>{' '}
    </Content>
   </div>
   <div className='imagediv'>
    <Image src={reviewImageone} />
   </div>
   <div className='bg'></div>
  </Reviewdiv>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 background: #fff;
 position: relative;
 .bg {
  position: absolute;
  width: 40%;
  height: 100%;
  background-color: #90d62b;
  top: 0;
  right: 0;
  z-index: 10;
  clip-path: polygon(19% 0, 100% 0, 100% 100%, 82% 100%);
 }
 @media screen and (max-width: 600px) {
  .bg {
   clip-path: polygon(18% 0, 100% 44%, 100% 0);
  }
 }
`;

const Wrapper = styled.div`
 width: 75%;
 margin: 0 auto 0rem auto;
 padding-top: 2rem;
 * {
  z-index: 200;
 }
 .header {
  width: fit-content;
 }
`;

//Info Section
const InfoContainer = styled.div`
 display: flex;
 align-items: center;
 width: 100%;
 justify-content: space-between;
 margin-top: 10rem;
 > div:first-child {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
 }
 > div:nth-child(2) {
  width: 45%;
 }
 div {
  height: 100%;
 }
 .header {
  width: fit-content;
 }
 @media screen and (max-width: 600px) {
  flex-direction: column-reverse;
  > div:first-child {
   width: 90%;
  }
  > div:nth-child(2) {
   width: 90%;
  }
 }
`;

const Heading = styled.h1`
 font-size: 2.5rem;
 font-weight: 700;
 line-height: 7rem;
 /* font-family: 'Segoe UI'; */
 color: #90d62b;
 text-transform: uppercase;
`;

const Linebreak = styled.div`
 width: 50%;
 display: flex;
 gap: 0.5rem;
 margin-top: -1.5rem;
 div {
  background-color: #84d908;
  border-radius: 1rem;
  height: 0.5vh;
 }
 .part1 {
  width: 40%;
 }
 .part2 {
  width: 30%;
 }
 .part3 {
  width: 10%;
 }
`;

const Content = styled.div`
 margin-top: 2rem;
 /* font-family: 'Segoe UI'; */
 color: #707070;
 text-align: justify;
 display: flex;
 flex-direction: column;
 gap: 2rem;
 h3 {
  font-size: 2.2rem;
  font-weight: 400;
  line-height: 2, 8rem;
  text-transform: capitalize;
 }
 p {
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2rem;
 }
`;

const Image = styled.img`
 width: 100%;
 height: auto;
 object-fit: cover;
`;

const Buttondiv = styled.div`
 padding-top: 4rem;
 width: 70%;
 margin: 0 auto;
 display: flex;
 justify-content: space-evenly;
 gap: 2rem;
 .button {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  color: #e8e8e8;
  font-size: 1.5rem;
  width: fit-content;
  padding: 0.5rem 2rem;
  font-weight: 600;
  cursor: none;
  background: linear-gradient(135deg, #575757 0%, #292929 100%);
  box-shadow: -5.88124px 5.88124px 11.7625px rgba(216, 216, 216, 0.2),
   5.88124px -5.88124px 11.7625px rgba(216, 216, 216, 0.2),
   -5.88124px -5.88124px 11.7625px rgba(255, 255, 255, 0.9),
   5.88124px 5.88124px 15.1232px rgba(216, 216, 216, 0.9),
   inset 0.840178px 0.840178px 1.68036px rgba(255, 255, 255, 0.3),
   inset -0.840178px -0.840178px 1.68036px rgba(216, 216, 216, 0.5);
 }
`;

const Reviewdiv = styled.div`
 display: flex;
 width: 60%;
 margin: 0 auto;
 background-color: #fff;
 border-radius: 2rem;
 margin-top: 8rem;
 padding: 2rem 4rem;
 gap: 2rem;
 margin-bottom: -5rem;
 position: relative;
 z-index: 500;
 filter: drop-shadow(0px 4px 76px rgba(0, 0, 0, 0.25));
 .review {
  width: 60%;
  height: 100%;
 }
 .imagediv {
  width: 40%;
  height: 100%;
  align-self: center;
  text-align: center;
  margin-left: 4rem;
 }
 img {
  width: 70%;
  height: auto;
  object-fit: cover;
 }
 p {
  text-align: justify;
  font-size: 1.3rem;
 }
 .bg {
  position: absolute;
  width: 40%;
  height: 100%;
  background-color: #90d62b;
  border-radius: 0 2rem 2rem 0;
  top: 0;
  right: 0;
  z-index: -2;
  clip-path: polygon(25% 0, 100% 0, 100% 100%, 0% 100%);
 }

 @media screen and (max-width: 600px) {
  flex-direction: column;
  width: 100%;
  .review {
   width: 100%;
  }
  .imagediv {
   width: 90%;
   margin-left: 0;
  }
 }
`;
